import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import "../css/adminLogin.css";
import { useNavigate } from 'react-router-dom';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const adminLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://petme.onrender.com/admin/adminlogin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          password
        })
      });

      if (res.status === 422) {
        const responseData = await res.json();
        window.alert(responseData.error);
      } else if (res.status === 200) {
        const responseData = await res.json();
        window.alert(responseData.message);
        navigate("/adminCategories");
      } else {
        window.alert("Unexpected response status");
      }
    } catch (error) {
      console.error("Error:", error);
      window.alert("An error occurred while processing your request.");
    }
  };

  return (
    <div>
      <div className="admin-bg_img"></div>
      <div className="admin-div">
        <div className="admin-background-content">
          <h1 className="admin-login">Log In</h1>
          <p className="admin-please-signin">Please Login to Continue</p>
          <form className="form admin-form">
            <input
              id="email"
              type="email"
              name="email"
              className="box admin-login-box"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email address"
            />
            <input
              id="password"
              type="password"
              name="password"
              className="box admin-login-box"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="password"
            />
            <NavLink
              id="submit"
              className="admin-submit-btn"
              onClick={adminLogin}
            >
              LOGIN
            </NavLink>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
